import { render, staticRenderFns } from "./openBill.vue?vue&type=template&id=1c05afaa&scoped=true&"
import script from "./openBill.vue?vue&type=script&lang=js&"
export * from "./openBill.vue?vue&type=script&lang=js&"
import style0 from "./openBill.vue?vue&type=style&index=0&id=1c05afaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c05afaa",
  null
  
)

export default component.exports